export function asyncAddExtenalScript(url: string, attributes: LooseObject = {}) {
  return new Promise<HTMLScriptElement | void>((resolve, reject) => {
    const existing = document.querySelectorAll(`script[src="${url}"]`);
    if (existing != undefined && existing.length > 0) {
      resolve();
      return;
    }
    let script = document.createElement('script');

    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', url);

    for (let key in attributes) {
      script.setAttribute(key, attributes[key]);
    }

    script.addEventListener('load', () => resolve(script), false);
    script.addEventListener('error', () => reject(script), false);
    document.body.appendChild(script);
  });
}

export function asyncAddExtenalStylesheet(url: string, attributes: LooseObject = {}) {
  return new Promise((resolve, reject) => {
    let link = document.createElement('link');

    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);

    for (let key in attributes) {
      link.setAttribute(key, attributes[key]);
    }

    link.addEventListener('load', () => resolve(link), false);
    link.addEventListener('error', () => reject(link), false);
    document.body.appendChild(link);
  });
}
